import type { ActionContext, ActionTree } from 'vuex'
import type { RootState } from '@/store'
import type { MapCoords, MapState, UpdateSettingsPayload } from './types'
import { MAP_ACTIONS, MAP_MUTATIONS } from './types'

const HIGH_RESOLUTION_ZOOM_LEVEL = 16

interface IMapActions extends ActionTree<MapState, RootState> {
  [MAP_ACTIONS.START_MOVING](context: ActionContext<MapState, RootState>, device: unknown): void
  [MAP_ACTIONS.STOP_MOVING](context: ActionContext<MapState, RootState>): void
  [MAP_ACTIONS.CANCEL_MOVE](context: ActionContext<MapState, RootState>): void
  [MAP_ACTIONS.SET_ZOOM](context: ActionContext<MapState, RootState>, zoom: number): void
  [MAP_ACTIONS.SET_CENTER](context: ActionContext<MapState, RootState>, center: MapCoords): void
  [MAP_ACTIONS.UPDATE_SETTINGS](
    context: ActionContext<MapState, RootState>,
    data: UpdateSettingsPayload
  ): void
  [MAP_ACTIONS.START_DEVICE_VIEW_MODE](
    context: ActionContext<MapState, RootState>,
    device: unknown
  ): void
  [MAP_ACTIONS.STOP_DEVICE_VIEW_MODE](context: ActionContext<MapState, RootState>): void
}

const actions: IMapActions = {
  [MAP_ACTIONS.START_MOVING]({ commit, state }, device) {
    commit(MAP_MUTATIONS.SET_LAST_ZOOM, state.location.zoom)
    commit(MAP_MUTATIONS.SET_ZOOM, HIGH_RESOLUTION_ZOOM_LEVEL)
    commit(MAP_MUTATIONS.SET_MOVING_PIN, device)
    commit(MAP_MUTATIONS.SET_MOVING_MODE, true)
    commit(MAP_MUTATIONS.UPDATE_LOCATION)
  },
  [MAP_ACTIONS.STOP_MOVING]({ commit }) {
    commit(MAP_MUTATIONS.SET_MOVING_MODE, false)
  },
  [MAP_ACTIONS.CANCEL_MOVE]({ commit, state }) {
    commit(MAP_MUTATIONS.SET_ZOOM, state.location.lastZoom)
    commit(MAP_MUTATIONS.SET_MOVING_MODE, false)
    commit(MAP_MUTATIONS.UPDATE_LOCATION)
  },
  [MAP_ACTIONS.SET_ZOOM]({ commit }, zoom) {
    commit(MAP_MUTATIONS.SET_ZOOM, zoom)
    commit(MAP_MUTATIONS.UPDATE_LOCATION)
  },
  [MAP_ACTIONS.SET_CENTER]({ commit }, center) {
    commit(MAP_MUTATIONS.SET_CENTER, center)
    commit(MAP_MUTATIONS.UPDATE_LOCATION)
  },
  [MAP_ACTIONS.UPDATE_SETTINGS]({ commit }, data) {
    commit(MAP_MUTATIONS.UPDATE_SETTINGS, data)
  },
  [MAP_ACTIONS.START_DEVICE_VIEW_MODE]({ commit, state }, device) {
    commit(MAP_MUTATIONS.SET_LAST_ZOOM, state.location.zoom)
    commit(MAP_MUTATIONS.SET_ZOOM, HIGH_RESOLUTION_ZOOM_LEVEL)
    commit(MAP_MUTATIONS.SET_DEVICE_VIEW_MODE, true)
    commit(MAP_MUTATIONS.SET_DEVICE_TO_VIEW, device)
    commit(MAP_MUTATIONS.UPDATE_LOCATION)
  },
  [MAP_ACTIONS.STOP_DEVICE_VIEW_MODE]({ commit }) {
    commit(MAP_MUTATIONS.SET_DEVICE_VIEW_MODE, false)
    commit(MAP_MUTATIONS.SET_DEVICE_TO_VIEW, null)
  }
}

export default actions
